<template>
  <div class="row">
    <div class="col-lg-3"></div>
    <div class="col-lg-6 col-12">
      <div class="card mt-3 bg-white">
        <div class="card-body color-grey-primary">
          <p class="f16">
            VOCÊ ESTÁ SE CANDIDATANDO PARA: <strong>{{ job.title }}</strong>
          </p>
          <div class="row">
            <div class="col-lg-12 col-12">
              <inputform
                v-model="candidate.linkedin_url"
                :field="{ $error: false, $invalid: true }"
                :type="'text'"
                placeholder="PERFIL LINKEDIN EX: https://www.linkedin.com/in/username/  "
              />
              <label class="mb-4">
                <input
                  v-model="candidate.scrape_linkedin"
                  class="mr-1 ml-1"
                  type="checkbox"
                />
                <span class="f15">
                  AUTORIZO A JOVOOL A BUSCAR DADOS ATRAVÉS DO MEU PERFIL NO
                  LINKEDIN
                </span>
              </label>
            </div>
            <div v-if="isNameValid" class="col-lg-12 col-12 mb-3">
              <input
                v-model="candidate.name"
                :field="{ $error: false, $invalid: true }"
                class="form-control"
                placeholder="NOME COMPLETO*"
                type="text"
              />
            </div>
            <div
              v-if="!candidate_data.cpf || !isValidCpf(candidate_data.cpf)"
              class="col-lg-12 col-12 mb-3"
            >
              <inputform
                v-model="candidate.cpf"
                v-mask="'###.###.###-##'"
                :field="$v.candidate.cpf"
                placeholder="CPF*"
                type="text"
              />
            </div>

            <div v-if="job.allow_rg" class="col-lg-12 col-12">
              <inputform
                v-model="candidate.rg"
                v-mask="['##.###.###-X', '###.###.###-##']"
                :field="
                  job.allow_rg
                    ? $v.candidate.rg
                    : { $error: false, $invalid: false }
                "
                placeholder="RG*"
                type="text"
              />
            </div>

            <div v-if="job.show_genre" class="col-lg-12 col-12 mb-3">
              <select
                v-model="candidate.gender"
                class="form-control"
                placeholder="IDENTIDADE DE GENÊRO*"
              >
                <option :value="-1">IDENTIDADE DE GENÊRO</option>
                <option
                  v-for="(gender, gender_index) in genders"
                  :key="`gender_${gender_index}`"
                  :data-placement="gender.tooltip_text ? 'top' : ''"
                  :data-toggle="gender.tooltip_text ? 'tooltip' : ''"
                  :title="gender.tooltip_text ? gender.tooltip_text : ''"
                  :value="gender.value"
                >
                  {{ gender.label }}
                </option>
              </select>
            </div>

            <div v-if="job.mandatory_portfolio" class="col-lg-12 col-12">
              <inputform
                v-model="candidate.personal_site"
                :field="{ $error: false, $invalid: true }"
                placeholder="https://site_pessoal.com.br(opcional)*"
                type="text"
              />
            </div>

            <div v-if="job.mandatory_portfolio" class="col-lg-12 col-12">
              <inputform
                v-model="candidate.personal_portfolio"
                :field="{ $error: false, $invalid: true }"
                placeholder="LINK PORTFÓLIO, EX: GITHUB*"
                type="text"
              />
            </div>

            <div v-if="job.question_last_work" class="col-lg-12 col-12">
              <inputform
                v-model="candidate.last_role"
                :field="{ $error: false, $invalid: true }"
                placeholder="ÚLTIMO CARGO QUE TRABALHOU / OU ATUAL"
                type="text"
              />
            </div>

            <div v-if="job.question_last_work" class="col-lg-12 col-12">
              <inputform
                v-model="candidate.last_business"
                :field="{ $error: false, $invalid: true }"
                placeholder="ÚLTIMA EMPRESA QUE TRABALHOU / OU ATUAL"
                type="text"
              />
            </div>

            <div class="col-lg-6 col-12">
              <inputform
                v-model="candidate.date_birth"
                v-mask="'##/##/####'"
                :field="$v.candidate.date_birth"
                placeholder="DATA DE NASCIMENTO*"
                type="text"
              />
            </div>

            <div class="col-lg-6 col-12">
              <inputform
                v-model="candidate.mobile_phone"
                v-mask="
                  candidate.mobile_phone && candidate.mobile_phone.length > 18
                    ? '+## (##) #####-####'
                    : '+## (##) ####-####'
                "
                :field="$v.candidate.mobile_phone"
                class="mb-0"
                placeholder="CELULAR"
                type="text"
              />
              <p class="mb-0 mt-0 f12">Ex.: +55 (99) 99999-9999</p>
            </div>

            <div v-if="job.has_ethnicity" class="col-lg-6 col-12 mt-3">
              <select
                v-model="candidate.ethnicity"
                class="form-control"
                placeholder="ETNIA/RAÇA*"
              >
                <option :value="-1">ETNIA/RAÇA</option>
                <option
                  v-for="(ethnicity, ethnicity_index) in ethnicities"
                  :key="`ethinicity_${ethnicity_index}`"
                  :value="ethnicity.value"
                >
                  {{ ethnicity.label }}
                </option>
              </select>
            </div>
            <div v-if="job.has_ethnicity" class="col-lg-6 col-12 mt-3">
              <select
                v-model="candidate.sexual_orientation"
                class="form-control"
                placeholder="Orientação Sexual*"
              >
                <option :value="-1">ORIENTAÇÃO SEXUAL</option>
                <option
                  v-for="(
                    sexual_orientation, sexual_orientation_index
                  ) in sexual_orientations"
                  :key="`sexual_orientation_${sexual_orientation_index}`"
                  :value="sexual_orientation.value"
                >
                  {{ sexual_orientation.label }}
                </option>
              </select>
              <inputform
                v-if="
                  candidate.sexual_orientation === 6 &&
                  !extra_options.sexual_orientation.length > 0
                "
                v-model="candidate.sexual_orientation_description"
                :field="{ $error: false, $invalid: true }"
                placeholder="Defina aqui"
                type="text"
              />
            </div>

            <div class="col-lg-12 col-xs-12">
              <VueSuggestion
                v-if="!is_exterior_city"
                :focusOut="hasCity"
                :selectedEl="city"
                :whenSelected="setCity"
                classes="mt-3"
                placeholder="CIDADE DE RESIDÊNCIA ATUAL*"
                responseDataName="cities"
                searchURL="/cities"
                @blur="cityChange"
              />
              <input
                v-if="is_exterior_city"
                v-model="candidate.exterior_city"
                :class="{
                  'is-invalid': is_exterior_city && !!!candidate.exterior_city,
                }"
                class="vs__input mt-2"
                placeholder="CIDADE(EXTERIOR)"
                type="text"
              />
              <input v-model="is_exterior_city" type="checkbox" />
              <span class="font-weight-bold"> Exterior </span>
            </div>
            <div v-if="job.has_hometown" class="col-lg-12 col-xs-12">
              <VueSuggestion
                :focusOut="hasHometown"
                :selectFirst="true"
                :selectedEl="hometown"
                :whenSelected="setHometown"
                classes="mt-3"
                placeholder="CIDADE NATAL*"
                responseDataName="cities"
                searchURL="/cities"
              />
            </div>
            <div v-if="job.has_is_pcd" class="col-lg-12 col-xs-12">
              <p class="mt-3 mb-0 pb-0">PCD?</p>
              <label class="mr-3">
                <input
                  v-model="candidate.is_pcd"
                  :value="true"
                  name="pcd"
                  type="radio"
                />
                Sim
              </label>

              <label>
                <input
                  v-model="candidate.is_pcd"
                  :value="false"
                  name="pcd"
                  type="radio"
                />
                Não
              </label>

              <div v-if="candidate.is_pcd" class="mt-2">
                <inputform
                  v-model="candidate.pcd_description"
                  :field="{ $error: false, $invalid: true }"
                  placeholder="Necessita de alguma adaptação ou ferramenta de acessibilidade?"
                  type="text"
                />
              </div>
            </div>
            <div
              v-if="job.allow_city_interest"
              class="col-lg-12 col-xs-12 mb-3"
            >
              <VueSuggestion
                :focusOut="hasCityInterest"
                :selectFirst="true"
                :selectedEl="city_interest"
                :whenSelected="setCityInterest"
                classes="mt-3"
                placeholder="LOCAL DE INTERESSE*"
                responseDataName="cities"
                searchURL="/cities"
              />
            </div>
            <div v-if="job.allow_address" class="col-lg-12 col-xs-12 mb-3">
              <hr />
              <p class="mt-3 mb-0 pb-0 mb-2 font-weight-bold">ENDEREÇO:</p>
              <inputform
                v-model="candidate.address.cep"
                :field="{ $error: false, $invalid: true }"
                placeholder="CEP*"
                type="text"
              />
              <inputform
                v-model="candidate.address.address"
                :field="{ $error: false, $invalid: true }"
                placeholder="ENDEREÇO*"
                type="text"
              />
              <inputform
                v-model="candidate.address.number"
                :field="{ $error: false, $invalid: true }"
                placeholder="NÚMERO*"
                type="text"
              />
              <inputform
                v-model="candidate.address.complement"
                :field="{ $error: false, $invalid: true }"
                placeholder="COMPLEMENTO"
                type="text"
              />
            </div>
            <div
              v-if="job.allow_reference_contacts"
              class="col-lg-12 col-xs-12 mb-3"
            >
              <hr />
              <p class="mt-3 mb-0 pb-0 mb-2 font-weight-bold">
                CONTATOS DE REFERÊNCIA:
              </p>
              <div class="row">
                <div class="col-6">
                  <inputform
                    v-model="candidate.first_contact_name"
                    :field="{ $error: false, $invalid: true }"
                    placeholder="Nome do contato 1*"
                    type="text"
                  />
                </div>
                <div class="col-6">
                  <inputform
                    v-model="candidate.first_contact_number"
                    v-mask="
                      candidate.first_contact_number &&
                      candidate.first_contact_number.length > 18
                        ? '+55 (##) #####-####'
                        : '+55 (##) ####-####'
                    "
                    :field="{ $error: false, $invalid: true }"
                    placeholder="Número do contato 1*"
                    type="text"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <inputform
                    v-model="candidate.second_contact_name"
                    :field="{ $error: false, $invalid: true }"
                    placeholder="Nome do contato 2*"
                    type="text"
                  />
                </div>
                <div class="col-6">
                  <inputform
                    v-model="candidate.second_contact_number"
                    v-mask="
                      candidate.second_contact_number &&
                      candidate.second_contact_number.length > 18
                        ? '+55 (##) #####-####'
                        : '+55 (##) ####-####'
                    "
                    :field="{ $error: false, $invalid: true }"
                    placeholder="Número do contato 2*"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div v-if="job.uid == 'dni2fnvg'" class="col-lg-12 col-xs-12">
              <p class="mt-3 mb-0 pb-0">Já trabalhou no Credit Suisse / UBS?</p>
              <label class="mr-3">
                <input
                  v-model="candidate.been_creditsuisse"
                  :value="true"
                  name="been_creditsuisse"
                  type="radio"
                />
                Sim
              </label>

              <label>
                <input
                  v-model="candidate.been_creditsuisse"
                  :value="false"
                  name="been_creditsuisse"
                  type="radio"
                />
                Não
              </label>
            </div>
            <div v-if="job.uid == 'dni2fnvg'" class="col-lg-12 col-xs-12">
              <p class="mt-3 mb-0 pb-0">
                Trabalha atualmente no Credit Suisse / UBS?
              </p>
              <label class="mr-3">
                <input
                  v-model="candidate.current_creditsuisse"
                  :value="true"
                  name="current_creditsuisse"
                  type="radio"
                />
                Sim
              </label>

              <label>
                <input
                  v-model="candidate.current_creditsuisse"
                  :value="false"
                  name="current_creditsuisse"
                  type="radio"
                />
                Não
              </label>
            </div>
            <div class="col-lg-12">
              <p class="mt-3 mb-0 pb-0">COMO FICOU SABENDO DA VAGA?</p>

              <select
                v-model="candidate.source"
                class="form-control"
                placeholder="COMO FICOU SABENDO DA VAGA?"
              >
                <option :value="'Redes Sociais'">Redes Sociais</option>
                <option :value="'Rocketseat'">Rocketseat</option>
                <option :value="'{reprograma}'">{reprograma}</option>
                <option :value="'Google'">Google</option>
                <option :value="'Linkedin'">Linkedin</option>
                <option :value="'Indicação'">Indicação</option>
                <option :value="'Universidade'">Universidade</option>
                <option :value="'Página da UBS'">Página UBS</option>
                <option :value="'BRASA'">BRASA</option>
                <option :value="'Outros'">Outros</option>
              </select>
            </div>
            <!-- <div class="col-12 mt-3">
              <textarea
                v-model="candidate.additional_info"
                class="form-control"
                maxlength="610"
                placeholder="INFORMAÇÕES ADICIONAIS QUE DESEJA COMPARTILHAR"
              ></textarea>
              <div class="d-flex justify-content-end">
                <small class="form-text text-muted">{{ candidate.additional_info.length }}/610</small>
              </div>
            </div> -->
            <div v-if="mandatory_questions.length > 0" class="col-12 mt-3 mb-3">
              <hr />
              <div
                v-for="(question, index) in mandatory_questions"
                :key="`question_${index}`"
              >
                <div
                  v-if="question.response_type == video_type"
                  class="videoPlay"
                >
                  <div
                    class="f18"
                    style="color: #000 !important"
                    v-html="question.title"
                  ></div>
                  <div class="d-flex justify-content-center">
                    <p
                      class="text-justify text-break"
                      style="width: 70%; text-align: center !important"
                    >
                      {{ question.details }}
                    </p>
                  </div>
                  <div v-show="error" class="center" style="color: #000">
                    <p>
                      <b>NÃO FOI POSSÍVEL ABRIR A CÂMERA</b>
                    </p>
                    <p class="f16">
                      TENTE GRAVAR USANDO DIRETO AS CÂMERAS DE SEU CELULAR OU
                      FAZER UPLOAD DO SEU VÍDEO, CLICANDO NO BOTÃO A BAIXO
                    </p>
                  </div>
                  <div v-if="video">
                    <p class="f16">
                      <b>Resposta gravada:</b>
                    </p>
                    <video
                      v-if="video"
                      id="video_answers"
                      controls
                      controlslist="nodownload"
                      playsinlineatributo
                      preload="yes"
                      style="max-height: 500px"
                      width="100%"
                    >
                      <source :src="video" type="video/mp4" />
                    </video>
                    <hr />
                  </div>
                  <p v-if="video" class="f16">
                    <b>Deseja gravar uma nova resposta?</b>
                  </p>
                  <VideoJSRecordMobile
                    v-if="ios"
                    :index="index"
                    :question="question"
                  />
                  <VideoJSRecord
                    v-if="!ios"
                    :index="index"
                    :question="question"
                  />
                </div>
              </div>
              <hr />
            </div>

            <div
              v-if="candidate.accept_terms == false"
              class="col-lg-12 col-xs-12 mt-1"
            >
              <label>
                <input
                  v-model="conditions"
                  class="mt-2 ml-1"
                  type="checkbox"
                  @change="changeConditions"
                />
                <span
                  >Ao se candidatar a está vaga você Aceita e Concorda com
                  nossos</span
                >
                <a href="/termos_de_uso" style="color: blue">Termos de Uso</a>
                <span>e</span>
                <a href="/politicas_de_privacidade" style="color: blue"
                  >Política de Privacidade</a
                >
              </label>
            </div>

            <div class="col-lg-12 col-12">
              <button
                :disabled="load"
                class="btn mt-2 full btn-success"
                type="button"
                @click="register"
              >
                <span v-show="!load">
                  <span class="mr-3">SALVAR</span>
                  <font-awesome-icon icon="chevron-right" />
                </span>
                <div
                  v-show="load"
                  class="spinner-border text-light"
                  role="status"
                >
                  <span class="sr-only"></span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import VideoJSRecord from "components/VideoJSRecord.vue";
import VideoJSRecordMobile from "components/VideoJSRecordMobile.vue";
import VueSuggestion from "components/VueSuggestion.vue";
import { format } from "date-fns";
import {
  isChrome,
  isMobile,
  isSafari,
  mobileModel,
  mobileVendor,
  osName,
} from "mobile-device-detect";

export default {
  props: [
    "job",
    "candidate_data",
    "selective_process",
    "account_uid",
    "extra_options",
    "apply",
    "mandatory_questions",
  ],
  components: { VueSuggestion, VideoJSRecord, VideoJSRecordMobile },
  mounted() {
    const second_postback_url = localStorage.getItem("second_postback_url");
    if (second_postback_url) {
      fetch(second_postback_url).then((response) => {
        console.log("RODOU PRIMEIRO POSTBACK");
      });
      localStorage.removeItem("second_postback_url");
    }
    if (mobileModel == "iPhone") {
      this.ios = true;
    }

    if (
      (isMobile || mobileVendor == "Apple" || mobileVendor == "none") &&
      isSafari
    ) {
      this.ios = true;
    }

    if (isMobile && osName == "Android" && !isChrome) {
      this.ios = true;
    }
    eventBus.$on("errorCam", (response) => {
      this.ios = true;
      this.error = true;
    });
    eventBus.$on("videoRecorded", (response) => {
      this.is_video_valid = true;
    });
    this.$toast.success("Registro salvo com sucesso");
    this.checkExtraOptions();
    if (this.candidate_data) {
      if (this.mandatory_questions.length > 0) {
        this.mandatory_questions.forEach((question) => {
          axios
            .get(`/candidates/answers/questions/${question.id}`)
            .then((response) => {
              if (response.data?.url) {
                this.video = response.data.url;
                let video = document.getElementById("video_answers");
                if (video) {
                  video.load();
                }
                this.is_video_valid = true;
              }
            });
        });
      }
      let cpf = null;
      if (this.candidate_data.cpf) {
        if (this.candidate_data.cpf.length < 16) {
          cpf = this.candidate_data.cpf;
        }
      }

      this.candidate = {
        date_birth: this.candidate_data.date_birth
          ? format(new Date(this.candidate_data.date_birth), "dd/MM/yyyy")
          : "",
        ethnicity:
          this.candidate_data.ethnicity == null
            ? -1
            : this.candidate_data.ethnicity,
        mobile_phone: this.candidate_data.mobile_phone,
        gender:
          this.candidate_data.gender == null ? -1 : this.candidate_data.gender,
        sexual_orientation:
          this.candidate_data.sexual_orientation == null
            ? -1
            : this.candidate_data.sexual_orientation,
        sexual_orientation_description:
          this.candidate_data.sexual_orientation_description,
        personal_portfolio: this.candidate_data.personal_portfolio,
        personal_site: this.candidate_data.personal_site,
        city_id: this.candidate_data.city_id,
        last_role: this.candidate_data.last_role,
        last_business: this.candidate_data.last_business,
        scrape_linkedin: this.candidate_data.scrape_linkedin,
        linkedin_url: this.candidate_data.linkedin_url || "",
        accept_terms: this.candidate_data.accept_terms,
        accept_politcs: this.candidate_data.accept_terms
          ? this.candidate_data.accept_terms
          : this.candidate_data.accept_politcs,
        is_pcd: this.candidate_data.is_pcd,
        pcd_description: this.candidate_data.pcd_description,
        source: this.candidate_data.source,
        cpf: cpf,
        rg: this.candidate_data.rg,
        been_creditsuisse: this.candidate_data.been_creditsuisse,
        current_creditsuisse: this.candidate_data.current_creditsuisse,
        name: this.candidate_data.name,
        exterior_city: this.candidate_data.exterior_city || "",
        additional_info: this.candidate_data.additional_info || "",
        address: {
          cep: this.candidate_data.address.cep || "",
          address: this.candidate_data.address.address || "",
          number: this.candidate_data.address.number || "",
          complement: this.candidate_data.address.complement || "",
        },
      };

      if (
        this.job.allow_reference_contacts &&
        this.candidate_data.reference_contacts?.contacts?.length > 0
      ) {
        this.candidate.first_contact_name =
          this.candidate_data.reference_contacts.contacts[0].name;
        this.candidate.first_contact_number =
          this.candidate_data.reference_contacts.contacts[0].mobile_phone;

        this.candidate.second_contact_name =
          this.candidate_data.reference_contacts.contacts[1].name;
        this.candidate.second_contact_number =
          this.candidate_data.reference_contacts.contacts[1].mobile_phone;
      }

      if (!!this.candidate.exterior_city) this.is_exterior_city = true;

      this.city = {
        id: this.candidate_data.city_id ? this.candidate_data.city_id : 0,
        name: this.candidate_data.city_id
          ? this.candidate_data.city_name + " / " + this.candidate_data.state_uf
          : "",
      };

      this.hometown = {
        id: this.candidate_data.hometown_attributes
          ? this.candidate_data.hometown_attributes
          : 0,
        name: this.candidate_data.hometown_attributes
          ? this.candidate_data.hometown_attributes.name +
              " / " +
              this.candidate_data.hometown_state_attributes.uf || "-"
          : "",
      };

      this.city_interest = {
        id: this.apply.city_interest_attributes
          ? this.apply.city_interest_attributes
          : 0,
        name: this.apply.city_interest_attributes
          ? this.apply.city_interest_attributes.name +
              " / " +
              this.apply.state_interest_attributes.uf || "-"
          : "",
      };

      if (this.candidate_data.accept_terms == true) {
        this.conditions = true;
      }
    }
  },
  data: () => ({
    load: false,
    conditions: false,
    is_exterior_city: false,
    ios: false,
    video_type: 0,
    is_video_valid: false,
    error: false,
    video: null,
    city: {
      id: 0,
      name: "",
    },
    hometown: {
      id: 0,
      name: "",
    },
    city_interest: {
      id: 0,
      name: "",
    },
    candidate: {
      source: "",
      date_birth: "",
      mobile_phone: "",
      last_role: "",
      last_business: "",
      gender: -1,
      personal_portfolio: "",
      personal_site: "",
      city_id: 0,
      scrape_linkedin: true,
      linkedin_url: "",
      accept_terms: "",
      accept_politcs: "",
      current_creditsuisse: false,
      been_creditsuisse: false,
      cpf: "",
      rg: "",
      name: "",
      exterior_city: "",
      address: {},
      first_contact_name: "",
      first_contact_number: "",
      second_contact_name: "",
      second_contact_number: "",
      additional_info: "",
    },
    genders: [
      {
        value: 0,
        label: "CISGÊNERO MASCULINO",
        tooltip_text:
          "pessoa que se identifica com o gênero que lhe foi atribuído no momento de seu nascimento",
      },
      {
        value: 1,
        label: "CISGÊNERO FEMININO",
        tooltip_text:
          "pessoa que se identifica com o gênero que lhe foi atribuído no momento de seu nascimento",
      },
      {
        value: 2,
        label: "TRANSGÊNERO",
        tooltip_text:
          "pessoa que NÃO se identifica com o gênero que lhe foi atribuído no momento de seu nascimento. Exemplo: quando nasceu, disseram que era uma menina, mas se identifica como um menino.",
      },
      {
        value: 4,
        label: "NÃO-BINÁRIO",
        tooltip_text:
          "refere-se às pessoas que não se percebem como pertencentes a um gênero exclusivamente. Isso significa que sua identidade de gênero e expressão de gênero não são limitadas ao masculino e feminino.",
      },
      {
        value: 10,
        label: "OUTROS",
        tooltip_text: "",
      },
      {
        value: 3,
        label: "PREFIRO NÃO ME IDENTIFICAR",
        tooltip_text: "",
      },
    ],
    ethnicities: [
      { value: 1, label: "Branca" },
      { value: 2, label: "Preta" },
      { value: 3, label: "Parda" },
      { value: 5, label: "Prefiro não responder" },
      { value: 7, label: "Amarela" },
      { value: 8, label: "Indígena" },
      { value: 9, label: "Outra" },
    ],
    sexual_orientations: [
      { value: 0, label: "HETEROSSEXUAL" },
      { value: 1, label: "BISSEXUAL" },
      { value: 2, label: "PANSEXUAL" },
      { value: 4, label: "HOMOSSEXUAL" },
      { value: 5, label: "ASSEXUAL" },
      { value: 6, label: "OUTRO" },
      { value: 3, label: "PREFIRO NÃO INFORMAR" },
    ],
  }),
  computed: {
    isNameValid() {
      const name = this.candidate_data.name.split(" ");
      return name.length < 2;
    },
  },
  methods: {
    setCity(event) {
      this.city.id = event.id;
      this.city.name = event.title;
    },
    setHometown(event) {
      this.hometown.id = event.id;
      this.hometown.name = event.title;
    },
    setCityInterest(event) {
      this.city_interest.id = event.id;
      this.city_interest.name = event.title;
    },
    changeConditions() {
      this.candidate.accept_terms = this.conditions;
      this.candidate.accept_politcs = this.conditions;
    },
    valiedLinkedin() {
      return true;
      if (
        !this.job.require_linkedin_url &&
        (this.candidate.linkedin_url == "" || !this.candidate.linkedin_url)
      )
        return true;

      if (
        this.job.require_linkedin_url &&
        (this.candidate.linkedin_url == "" || !this.candidate.linkedin_url)
      )
        return false;

      if (!this.candidate.scrape_linkedin) {
        alert(
          "Tem certeza que não deseja utilizar seus dados do linkedin?, isso acelera seu processo de cadastro"
        );
      }
      if (!this.candidate.linkedin_url.includes("https")) {
        this.candidate.linkedin_url = "https://" + this.candidate.linkedin_url;
      }
      let url = this.candidate.linkedin_url.split(
        "https://www.linkedin.com/in/"
      );
      let url2 = this.candidate.linkedin_url.split(
        "https://br.linkedin.com/in/"
      );

      if (url.length != 2 && url2.length != 2) {
        this.$toast.error("Url (link) inválida");
        return false;
      }
      if (url[1]?.length <= 3 && url2[1]?.length <= 3) {
        this.$toast.error("Url (link) inválida");
        return false;
      }
      return true;
    },
    sendLinkedin() {
      return;
      // if (!this.valiedLinkedin()) return;
      // if (this.candidate.linkedin_url == "") return true;
      // axios.post("/candidates/scrape_linkedin", {
      //   candidates: {
      //     scrape_linkedin: this.candidate.scrape_linkedin,
      //     linkedin_url: this.candidate.linkedin_url,
      //   },
      //   allow_institution: this.job.allow_institution_reparse,
      // });
    },
    cityChange(event) {
      if (!event?.id) {
        this.city = { id: 0, name: "" };
      }
    },
    async register() {
      this.load = true;
      this.$v.candidate.$touch();

      // if (this.job.uid == "dni2fnvg") {
      //   if (!this.candidate.source || this.candidate.source == "") {
      //     this.$toast.error("Preencha o campo 'onde conheceu o programa'", {
      //       position: "top",
      //     });
      //     this.load = false;
      //     return;
      //   }
      // }
      if (this.$v.candidate.$error) {
        this.$toast.error(
          "Por favor, verifique e corrija os campos destacados em vermelho antes de continuar",
          {
            position: "top",
          }
        );
        this.load = false;
        return false;
      }

      // if (!this.valiedLinkedin()) {
      //   this.$toast.error("Preencha corretamente os campos para continuar", {
      //     position: "top",
      //   });
      //   this.load = false;
      //   return false;
      // }

      if (this.candidate.date_birth) {
        const year = new Date().getFullYear();
        var date = this.candidate.date_birth.split("/");
        if (date[2] > year || date[2] < 1900) {
          this.$toast.error("Preencha corretamente sua data de nascimento", {
            position: "top",
          });
          this.load = false;
          return false;
        }
      }

      if (this.mandatory_questions.length > 0 && this.is_video_valid == false) {
        this.$toast.error("Grave o vídeo para continuar.", {
          position: "top",
        });
        this.load = false;
        return false;
      }

      if (!this.conditions) {
        this.$toast.error(
          "Você precisa Aceitar e Concordar com nossos Termos de Uso e Política de Privacidade",
          {
            position: "top",
          }
        );
        this.load = false;
        return false;
      }

      if (this.city.id == 0 && !this.is_exterior_city) {
        this.$toast.error("Preencha a cidade", {
          position: "top",
        });
        this.load = false;
        return false;
      }

      if (this.is_exterior_city && !!!this.candidate.exterior_city) {
        this.$toast.error("Preencha a cidade(exterior)", {
          position: "top",
        });
        this.load = false;
        return false;
      }

      if (!this.isValidCpf(this.candidate.cpf)) {
        this.$toast.error("cpf inválido, preencha corretamente");
        this.load = false;
        return false;
      }

      if (this.job.allow_rg && !this.candidate.rg) {
        this.$toast.error("RG inválido, preencha corretamente.");
        this.load = false;
        return false;
      }

      if (this.job.allow_address) {
        if (!this.candidate.address.cep) {
          this.$toast.error("CEP inválido, preencha corretamente.");
          this.load = false;
          return false;
        }
        if (!this.candidate.address.address) {
          this.$toast.error("Endereço inválido, preencha corretamente.");
          this.load = false;
          return false;
        }
        if (!this.candidate.address.number) {
          this.$toast.error("Número inválido, preencha corretamente.");
          this.load = false;
          return false;
        }
      }

      let reference_contacts = [];

      if (this.job.allow_reference_contacts) {
        if (!this.candidate.first_contact_name) {
          this.$toast.error("Preencha o nome do contato 1.");
          this.load = false;
          return false;
        }

        if (!this.candidate.first_contact_number) {
          this.$toast.error("Preencha o número do contato 1.");
          this.load = false;
          return false;
        }

        if (!this.candidate.second_contact_name) {
          this.$toast.error("Preencha o nome do contato 2.");
          this.load = false;
          return false;
        }

        if (!this.candidate.second_contact_number) {
          this.$toast.error("Preencha o número do contato 2.");
          this.load = false;
          return false;
        }

        reference_contacts = [
          {
            name: this.candidate.first_contact_name,
            mobile_phone: this.candidate.first_contact_number,
          },
          {
            name: this.candidate.second_contact_name,
            mobile_phone: this.candidate.second_contact_number,
          },
        ];
      }

      // if(!this.candidate_data.cpf){
      //   const cpfExists = await axios.post('/candidates/cpf/', { cpf: this.candidate.cpf, account_uid: this.account_uid }).then(response => {
      //     if(response.data.status == false) {
      //       return true;
      //     }
      //     return false;
      //   });
      //   if(cpfExists) {
      //     this.$toast.error("O CPF informado já foi cadastrado.");
      //     this.load = false;
      //     return false;
      //   }
      // }

      const name = this.candidate.name.split(" ");
      if (name.length < 2) {
        this.$toast.error("Preencha seu nome completo");
        this.load = false;
        return false;
      }

      this.candidate.city_id = this.city.id;

      if (this.candidate.gender == -1 && this.job.show_genre) {
        this.$toast.error("Preencha seu genêro", {
          position: "top",
        });
        this.load = false;
        return false;
      }

      if (
        this.extra_options?.sexual_orientation?.length == 0 &&
        this.candidate.sexual_orientation == 6 &&
        !this.candidate.sexual_orientation_description
      ) {
        this.$toast.error("Preencha sua orientação sexual", {
          position: "top",
        });
        this.load = false;
        return false;
      }

      if (!this.validDateBirth(this.candidate.date_birth)) {
        this.$toast.error(
          "Preencha sua data de nascimento corretamente, exemplo: 02/07/1982",
          {
            position: "top",
          }
        );
        this.load = false;
        return false;
      }
      let date_arr = this.candidate.date_birth.split("/");
      if (
        parseInt(date_arr[0]) > 31 ||
        parseInt(date_arr[1]) > 12 ||
        parseInt(date_arr[2]) > 2021 ||
        parseInt(date_arr[2]) < 1940
      ) {
        this.$toast.error(
          "Preencha sua data de nascimento corretamente, exemplo: 02/07/1982",
          {
            position: "top",
          }
        );
        this.load = false;
        return false;
      }

      // this.candidate.date_birth =
      //   date_arr[2] + "-" + date_arr[1] + "-" + date_arr[0];

      if (this.job.has_ethnicity) {
        if (this.candidate.ethnicity == -1) {
          this.$toast.error("Preencha a Etinia", {
            position: "top",
          });
          this.load = false;
          return false;
        }
      }

      if (this.job.has_sexual_orientation) {
        if (this.candidate.sexual_orientation == -1) {
          this.$toast.error("Preencha a Orientação sexual", {
            position: "top",
          });
          this.load = false;
          return false;
        }
      }

      if (this.job.has_hometown) {
        if (this.hometown.id == 0) {
          this.$toast.error("Preencha sua cidade natal", {
            position: "top",
          });
          this.load = false;
          return false;
        }
        this.candidate.hometown = this.hometown.id;
      }

      this.sendLinkedin();
      // setTimeout(() => {
      axios
        .put("/candidates", {
          candidates: {
            hometown: this.hometown.id,
            source: this.candidate.source,
            date_birth: date_arr[2] + "-" + date_arr[1] + "-" + date_arr[0],
            mobile_phone: this.candidate.mobile_phone,
            last_role: this.candidate.last_role,
            last_business: this.candidate.last_business,
            gender: this.candidate.gender,
            personal_portfolio: this.candidate.personal_portfolio,
            personal_site: this.candidate.personal_site,
            city_id: this.candidate.city_id,
            scrape_linkedin: this.candidate.scrape_linkedin,
            linkedin_url: this.candidate.linkedin_url,
            accept_terms: this.candidate.accept_terms,
            accept_politcs: this.candidate.accept_politcs,
            current_creditsuisse: this.candidate.current_creditsuisse,
            been_creditsuisse: this.candidate.been_creditsuisse,
            ethnicity: this.candidate.ethnicity,
            sexual_orientation: this.candidate.sexual_orientation,
            sexual_orientation_description:
              this.candidate.sexual_orientation_description,
            is_pcd: this.candidate.is_pcd,
            pcd_description: this.candidate.pcd_description,
            hometown: this.candidate.hometown,
            cpf: this.candidate.cpf,
            rg: this.candidate.rg,
            name: this.candidate.name,
            exterior_city: this.candidate.exterior_city,
            address: this.candidate.address,
            additional_info: this.candidate.additional_info,
            reference_contacts: { contacts: reference_contacts },
          },
        })
        .then((response) => {
          if (response.data.status == true) {
            this.$toast.success("Dados salvos com sucesso");
            if (this.selective_process.field_mapping_ids.length > 0) {
              eventBus.$emit("DataCollecFinished", { status: true });
              return;
            }
            eventBus.$emit("RegisterFinished", { status: true });
            return;
          }

          this.$toast.error("Erro ao salvar os dados");
          this.load = false;
        })
        .catch((error) => {
          this.$toast.error("Erro ao salvar os dados");
          this.load = false;
        });
      if (this.job.allow_city_interest) {
        axios.put("/candidates/apply/update_city_interest", {
          apply: {
            city_interest_id: this.city_interest.id,
          },
        });
      }
      // }, 1000);
    },
    validDateBirth(date) {
      let [day, mounth, year] = date.split("/").map((el) => parseInt(el));

      if (day > 31 || day <= 0) return false;
      if (mounth > 12 || mounth <= 0) return false;
      if (year >= new Date().getFullYear || year < 1950) return false;

      return true;
    },
    hasCity(event, items, select) {
      if (select) {
        this.city.id = select.id;
        this.city.name = select.name;
      } else {
        this.city = items[0] ? items[0] : { id: 0, name: "" };
      }
      if (!this.city)
        this.$toast.error("Por favor, informe a cidade de candidato(a).");
    },
    hasHometown(event, items, select) {
      if (select) {
        this.hometown.id = select.id;
        this.hometown.name = select.name;
      } else {
        this.hometown = items[0] ? items[0] : { id: 0, name: "" };
      }

      if (!this.hasHometown)
        this.$toast.error("Por favor, informe a cidade de candidato(a).");
    },
    hasCityInterest(event, items, select) {
      if (select) {
        this.city_interest.id = select.id;
        this.city_interest.name = select.name;
      } else {
        this.city_interest = items[0] ? items[0] : { id: 0, name: "" };
      }

      if (!this.city_interest)
        this.$toast.error("Por favor, informe o local de interesse.");
    },
    isValidCpf(cpf) {
      if (typeof cpf !== "string") return false;
      cpf = cpf.replace(/[\s.-]*/gim, "");
      if (
        !cpf ||
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      ) {
        return false;
      }
      var soma = 0;
      var resto;
      for (var i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return false;
      soma = 0;
      for (var i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
    checkExtraOptions() {
      if (this.extra_options) {
        this.extra_options?.gender?.length > 0
          ? (this.genders = this.extra_options?.gender?.map((gender, index) => {
              return { label: gender, value: index };
            }))
          : this.genders;

        this.extra_options?.ethnicity?.length > 0
          ? (this.ethnicities = this.extra_options?.ethnicity?.map(
              (ethnicity, index) => {
                return { label: ethnicity, value: index };
              }
            ))
          : this.ethnicities;

        this.extra_options?.sexual_orientation?.length > 0
          ? (this.sexual_orientations =
              this.extra_options?.sexual_orientation?.map(
                (sexual_orientation, index) => {
                  return { label: sexual_orientation, value: index };
                }
              ))
          : this.sexual_orientations;
      }
    },
  },
  validations: {
    candidate: {
      cpf: {
        required,
        cpf(value) {
          return this.isValidCpf(value);
        },
      },
      rg: {
        rg(value) {
          if (!this.job.allow_rg) return true;
          if (this.job.allow_rg && !value) return false;
          if (this.job.allow_rg && value) return true;
        },
      },
      date_birth: {
        dateBirth(value) {
          if (!value) return false;
          if (value.length < 10) return false;
          let date = value.split("/");
          if (date[0] > 31 || date[0] <= 0) return false;
          if (date[1] > 12 || date[1] <= 0) return false;
          if (date[2] > new Date().getFullYear() || date[2] < 1950)
            return false;
          return true;
        },
      },
      mobile_phone: {
        mobilePhone(value) {
          if (!this.job.require_mobile_phone && !this.candidate.mobile_phone)
            return true;
          if (!value) return false;
          if (value.length > 17 && value.length <= 19) return true;
          return false;
        },
      },
      linkedin_url: {},
      personal_portfolio: {},
      personal_site: {},
    },
  },
};
</script>
